import { SubmitButton, useIsMounted } from 'common'
import FormAdditionalData from 'components/FormAdditionalData'
import { AdditionalDataType } from 'components/FormAdditionalData/AdditionalData'
import InitialValuesAdditionalData from 'components/FormAdditionalData/InitialValuesAdditionalData'
import ValidationSchemaAdditionalData from 'components/FormAdditionalData/ValidationSchemaAdditionalData'
import { Formik } from 'formik'
import { Form } from 'react-bootstrap'
import FormPaymentData from 'shared_components/FormPaymentData'
import InitialValuesPaymentData from 'shared_components/FormPaymentData/InitialValuesPaymentData'
import { PaymentDataType } from 'shared_components/FormPaymentData/PaymentDataType'
import ValidationSchemaPaymentData from 'shared_components/FormPaymentData/ValidationSchemaPaymentData'
import FormPersonalData, {
    InitialValuesPersonalData,
    PersonalDataType,
    ValidationSchemaPersonalData,
} from 'shared_components/FormPersonalData'
import FormSportData, {
    InitialValuesSportData,
    SportDataType,
    ValidationSchemaSportData,
} from 'shared_components/FormSportData'
import styles from 'shared_components/forms.module.scss'
import * as Yup from 'yup'
import FormMembershipData from '../../shared_components/FormMembershipData/FormMembershipData'
import FormParentPersonalData from '../../shared_components/FormParentPersonalData/FormParentPersonalData'

export type RegistrationData = PersonalDataType & SportDataType & AdditionalDataType & PaymentDataType

interface Props {
    onCreate: (data: RegistrationData) => Promise<void>
}

const FormikBuilder = ({ onCreate }: Props): JSX.Element => {
    const isMounted = useIsMounted()

    const validationSchema = Yup.object()
        .shape(ValidationSchemaSportData)
        .shape(ValidationSchemaPersonalData)
        .shape(ValidationSchemaPaymentData)
        .shape(ValidationSchemaAdditionalData)

    return (
        <Formik
            enableReinitialize
            initialValues={{
                ...InitialValuesSportData,
                ...InitialValuesPersonalData,
                ...InitialValuesPaymentData,
                ...InitialValuesAdditionalData,
            }}
            validationSchema={validationSchema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={async (values, { setSubmitting }): Promise<void> => {
                setSubmitting(true)

                await onCreate(values)

                if (isMounted()) {
                    setSubmitting(false)
                }
            }}
        >
            {({ values, handleSubmit, handleReset, isSubmitting, errors, isValid, dirty }): JSX.Element => (
                <Form onSubmit={handleSubmit} onReset={handleReset} data-testid="form" className={styles.form}>
                    <FormMembershipData values={values} />
                    {values.personalData.membershipType === 'active' && (
                        <FormSportData
                            values={values}
                            dateOfBirth={values.personalData.dateOfBirth}
                            today={new Date()}
                            sportData={InitialValuesSportData}
                            errors={errors?.sportData}
                        />
                    )}
                    <FormPersonalData values={values} />
                    <FormParentPersonalData values={values} />
                    <FormPaymentData values={values} />
                    <FormAdditionalData values={values} />
                    <div className="text-right">
                        <SubmitButton disabled={!isValid || !dirty} isSubmitting={isSubmitting}>
                            Beitragspflichtiges Mitglied werden
                        </SubmitButton>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export default FormikBuilder
